module.exports = __webpack_public_path__ + "static/media/simerneet.fc8afc8a.jpg";